import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import axios from 'axios';
import config from './config.js';
import EventBus from './eventBus.js';

// Components
import Home from './components/Home';
import BookmarkCollection from './components/BookmarkCollection';
import ReadonlyBookmarkCollection from './components/ReadonlyBookmarkCollection';
import ImportCheckList from './components/ImportCheckList';
import About from './components/About';
import Ping from './components/Ping';
import ModalForm from './components/ModalForm';

// Styles
import './App.css';
import './assets/main.scss';

import logo from './assets/logo.png';
import bmcLogo from './assets/bmc-logo-white.svg';

function App() {
    const [showCreateCollectionModal, setShowCreateCollectionModal] = useState(false);
    const [message, setMessage] = useState('');
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const createCollectionFormFields = [
        {
            label: 'Title:',
            placeholder: 'Title',
            inputType: 'text',
            name: 'createCollectionTitle',
            id: 'title',
            optional: false,
            maxlength: 50
        },
        {
            label: 'Password (Optional):',
            placeholder: 'Password',
            inputType: 'password',
            name: 'createCollectionPassword',
            id: 'password',
            optional: true,
            maxlength: 30
        }
    ];

    useEffect(() => {
        EventBus.on('add-collection-form', () => {
            setShowCreateCollectionModal(true);
        });

        return () => {
            EventBus.off('add-collection-form');
        };
    }, []);

    const submitAddForm = (formData) => {
        axios.post(config.serverPath + '/api/addcollection', {
            'title': formData.title,
            'password': formData.password
        })
        .then((res) => {
            if (res.data.status === 'success') {
                setShowCreateCollectionModal(false);
                const inserted_id = res.data.inserted_id;
                window.location.href = '/bookmarks/' + inserted_id;
            } else {
                setMessage(res.data.message);
            }
        })
        .catch((error) => {
            console.log(error);
        });
    };

    return (
        <Router>
            <div className="min-h-screen">
                {/* Modern Navigation Bar */}
                <nav className="bg-white/80 backdrop-blur-md shadow-sm sticky top-0 z-40">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="flex justify-between items-center h-16">
                            {/* Logo */}
                            <a href="/" className="flex items-center">
                                <img src={logo} alt="Axomark" className="h-10" />
                            </a>

                            {/* Desktop Menu */}
                            <div className="hidden md:flex items-center gap-6">
                                <a href="/#howto" className="text-gray-700 hover:text-gray-900 font-medium transition-colors">
                                    How to use
                                </a>
                                <a href="/#about" className="text-gray-700 hover:text-gray-900 font-medium transition-colors">
                                    About
                                </a>
                                <button
                                    onClick={() => setShowCreateCollectionModal(true)}
                                    className="px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors shadow-md hover:shadow-lg"
                                >
                                    Create collection
                                </button>
                            </div>

                            {/* Mobile Menu Button */}
                            <button
                                onClick={() => setIsMenuOpen(!isMenuOpen)}
                                className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
                            >
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    {isMenuOpen ? (
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    ) : (
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                    )}
                                </svg>
                            </button>
                        </div>

                        {/* Mobile Menu */}
                        {isMenuOpen && (
                            <div className="md:hidden py-4 space-y-3">
                                <a href="/#howto" className="block py-2 text-gray-700 hover:text-gray-900 font-medium">
                                    How to use
                                </a>
                                <a href="/#about" className="block py-2 text-gray-700 hover:text-gray-900 font-medium">
                                    About
                                </a>
                                <button
                                    onClick={() => setShowCreateCollectionModal(true)}
                                    className="w-full px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors"
                                >
                                    Create collection
                                </button>
                            </div>
                        )}
                    </div>
                </nav>

                <ModalForm
                    isOpen={showCreateCollectionModal}
                    onClose={() => setShowCreateCollectionModal(false)}
                    formTitle="Create bookmark collection"
                    fields={createCollectionFormFields}
                    onSubmit={submitAddForm}
                    message={message}
                />

                <Routes>
                    <Route path="/bookmarks/:id" element={<BookmarkCollection />} />
                    <Route path="/bookmarks" element={<BookmarkCollection />} />
                    <Route path="/robookmarks/:id" element={<ReadonlyBookmarkCollection />} />
                    <Route path="/robookmarks" element={<ReadonlyBookmarkCollection />} />
                    <Route path="/import/pocket/:id" element={<ImportCheckList />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/ping" element={<Ping />} />
                    <Route path="/" element={<Home />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;
